<template>
	<!-- 招聘 -->
	<div class="content1">
		<header1 :pathname="pathname" @showMobile="showMobile"></header1>
		<div class="zp-h new-zp-h">
			<img src="../../assets/contactus/关于我们@2x.png" alt="">
			<div style="color: white;">Zhongjian is located in Hangzhou</div>
		</div>

		<div class="zp-c">
			<div class="zp-cc">
				<div class="zp-c-h">
					<div class="item">
						<img src="../../../public/imgs/contactus/编组 2@2x.png" alt="">
						address
					</div>
					<div class="item">
						<img src="../../../public/imgs/contactus/youxiang@2x.png" alt="">
						email
					</div>
					<div class="item">
						<img src="../../../public/imgs/contactus/编组 3@2x.png" alt="">
						phone
					</div>
				</div>
				<div class="zp-c-f" style="margin-top: 20px;">
					<div class="item">
						<!-- <div class="item-t">registered address</div> -->
						<!-- <div style="margin-bottom: 20px;">Room 405, 4th Floor, Building 4, No. 22 Kangzheng Road, Gongshu District, Hangzhou City, Zhejiang Province</div>
						<div class="item-t">Business Address</div> -->
						<div>3rd Floor, Building 5, No. 503 Xingguo Road, Linping District, Hangzhou City, Zhejiang Province</div>
					</div>
					<div class="item">
						zg@zgeec.com
					</div>
					<div class="item">
						0571-86392006
					</div>
				</div>
			</div>
		</div>

		<!-- <div class="map" id="map"> -->
			<div class="map">
			
			<img class="map-bg" src="../../assets/4021737342260_.pic_hd.jpg" alt="">
			<img class="map-img" src="../../assets/编组.png" alt="">
		</div>


		<footer1></footer1>
		<mobilemenu v-if="isShowMobile" @hiddenMobile="hiddenMobile"></mobilemenu>
	</div>
</template>

<script>
	import {
	  
	} from '@/api/home.js';
	import mobilemenu from "@/components/en/mobile-menu.vue";
	import AMapLoader from '@amap/amap-jsapi-loader';
	import header1 from "@/components/en/header.vue";
	import footer1 from "@/components/en/footer.vue";
	export default {
		components: {
			header1,
			footer1,
			mobilemenu
		},
		data() {
			return {
				pathname: "/en/contactus",
				isShowMobile:false
			}
		},
		mounted() {
			AMapLoader.load({
				key: 'a3120f4f6e653aac6e23ba8b147ed560',
				version: '2.0',
				plugins: ['AMap.Geolocation', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar',
					'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'
				],
				AMapUI: {
					version: '1.1',
					plugins: [],
				},
			}).then((AMap) => {
				const map = new AMap.Map('map', {
					zoom: 10,
					center: [116.397428, 39.90923], // 设置中心点坐标
				});

				// 你可以在这里进行地图的其他操作，例如添加标记、监听事件等
			}).catch(e => {
				console.log(e);
			});
		},
		created() {

		},
		methods: {
			showMobile() {
				console.log("ooooo")
				this.isShowMobile = true
			},
			hiddenMobile() {
				this.isShowMobile = false
			}

		}
	}
</script>

<style lang="scss">
	.content1 {
		.zp-h1 {
			width: 100%;
			// display: flex;
			// flex-direction: column;
			// justify-content: center;
			// align-items: center;
			position: relative;
			img {
				// object-fit: cover;
			}
			div {
				position: absolute;
				top: 0;
				left: 0;
				z-index: 11;
				width: 100%;
				
				
				font-family: AlibabaPuHuiTi-Regular;
				font-weight: 400;
				color: #22A3D3;;
				// position: relative;
				// z-index: 9;
			}
		}

		.zp-c {
			
			background-color: white;
			display: flex;
			justify-content: center;

			.zp-cc {
				

				.zp-c-h {
					display: flex;
					justify-content: space-between;

					.item {
						flex: 1;
						text-align: center;
						display: flex;
						flex-direction: column;
						justify-content: center;
						align-items: center;
						img {
							
						}
					}
				}

				.zp-c-f {
					justify-content: space-between;

					.item {
						flex: 1;
						text-align: center;
						font-weight: 400;
						color: #666666;

						.item-t {
							color: #332C2B;
						}
					}
				}
			}
		}

		.map {
			position: relative;
			.map-bg {
				position: absolute;
				z-index: 99999;
			}
			.map-img {
				position: absolute;
				z-index: 99999;
			}
		}

	}
	
	@media screen and (min-width: 1200px) {
		.content1 {
			padding-top: 100px;
			.zp-h1 {
				width: 100%;
				min-height: 500px;
				display: flex;
				img {
					width: 100%;
					min-height: 500px;
					height: 500px;
				}
				
				div {
					line-height: 100%;
					text-align: center;
					font-weight: 400;
					font-size: 48px;
					height: 100%;
				}
			}
		
			.zp-c {
				width: 100%;
				height: 400px;
				display: flex;
		
				.zp-cc {
					width: 1200px;
					padding: 30px 0;
		
					.zp-c-h {
						width: 100%;
						display: flex;
		
						.item {
							flex: 1;
							display: flex;
							font-size: 20px;
							img {
								width: 40px;
								height: 40px;
								margin-bottom: 32px;
							}
						}
					}
		
					.zp-c-f {
						display: flex;
		
						.item {
							flex: 1;
							font-size: 18px;
		
							.item-t {
								font-size: 18px;
								margin-bottom: 20px;
							}
						}
					}
				}
			}
		
			.map {
				width: 100%;
				height: 480px;
				.map-bg {
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
				}
				.map-img {
					top: calc(50% - 30px);
					left: calc(50% - 70px);
					width: 140px;
					height: 60px;
				}
			}
		}
	
	}
	@media screen and (max-width: 1200px) {
		.content1 {
			padding-top: 80px;
			.zp-h1 {
				width: 100%;
				min-height: 400px;
				display: flex;
				
				img {
					width: 100%;
					min-height: 400px;
					height: 400px;
				}
				div {
					line-height: 100%;
					text-align: center;
					font-weight: 400;
					font-size: 30px;
					height: 100%;
				}
			}
			
		
			.zp-c {
				width: 100%;
				height: 300px;
				display: flex;
		
				.zp-cc {
					width: 100%;
					padding: 20px 0;
		
					.zp-c-h {
						width: 100%;
						display: flex;
		
						.item {
							flex: 1;
							display: flex;
							font-size: 16px;
							img {
								width: 30px;
								height: 30px;
								margin-bottom: 22px;
							}
						}
					}
		
					.zp-c-f {
						display: flex;
		
						.item {
							flex: 1;
							font-size: 15px;
		
							.item-t {
								font-size: 15px;
								margin-bottom: 14px;
							}
						}
					}
				}
			}
		
			.map {
				width: 100%;
				height: 300px;
				.map-bg {
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
				}
				.map-img {
					top: calc(50% - 25px);
					left: calc(50% - 50px);
					width: 100px;
					height: 50px;
				}
			}
		}
	
	}
	@media screen and (max-width: 880px) {
		.content1 {
			padding-top: 50px;
			.zp-h1 {
				width: 100%;
				min-height: 300px;
				display: flex;
				img {
					width: 100%;
					min-height: 300px;
					height: auto;
				}
				
				div {
					line-height: 100%;
					text-align: center;
					font-weight: 400;
					font-size: 20px;
				}
			}
			
		
			.zp-c {
				width: 100%;
				padding: 20px 0;
				display: flex;
		
				.zp-cc {
					width: 100%;
					padding: 12px;
		
					.zp-c-h {
						width: 100%;
						display: flex;
		
						.item {
							flex: 1;
							display: flex;
							font-size: 13px;
							img {
								width: 20px;
								height: 20px;
								margin-bottom: 12px;
							}
						}
					}
		
					.zp-c-f {
						display: flex;
		
						.item {
							flex: 1;
							font-size: 14px;
		
							.item-t {
								font-size: 14px;
								margin-bottom: 10px;
							}
						}
					}
				}
			}
		
			.map {
				margin-top: 12px;
				width: 100%;
				height: 300px;
				
				.map-bg {
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
				}
				.map-img {
					top: calc(50% - 20px);
					left: calc(50% - 40px);
					width: 80px;
					height: 40px;
				}
			}
		}
	
	}
</style>
